import { render, staticRenderFns } from "./story_dec.vue?vue&type=template&id=49cfeb7a&scoped=true&"
import script from "./story_dec.vue?vue&type=script&lang=js&"
export * from "./story_dec.vue?vue&type=script&lang=js&"
import style0 from "./story_dec.vue?vue&type=style&index=0&id=49cfeb7a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cfeb7a",
  null
  
)

export default component.exports